let src = `https://maps.googleapis.com/maps/api/js`,
    alias = "__globalMap__",
    promise;

export default function(config) {
    return (promise =
        promise ||
        new Promise((resolve, reject) => {
            let search = [];
            for (let prop in config) {
                switch (prop) {
                    case "key":
                        if (config[prop]) search.push("key=" + config[prop]);
                        break;
                    case "libraries":
                        if (config[prop])
                            search.push("libraries=" + config[prop]);
                        break;
                }
            }

            let google = window.google || {};

            if (google.maps) return resolve(window.google.maps);

            search.push("callback=" + alias);

            let script = document.createElement("script");
            script.src = src + "?" + search.join("&");
            script.async = true;

            window[alias] = () => {
                resolve(window.google.maps);
            };

            document.head.appendChild(script);
        }));
}
